// Some WarEra country codes aren't valid ISO-3166 alpha-2, so their emoji flag
// doesn't render (e.g. "uk" → 🇺🇰 isn't a real flag; the UK is "gb" → 🇬🇧).
const CODE_FIXUPS: Record<string, string> = {
  uk: "gb",
};

/** ISO-2 country code → emoji flag. */
export function flag(code: string): string {
  const c = CODE_FIXUPS[code?.toLowerCase()] ?? code;
  if (!c || c.length !== 2) return "🏳️";
  const base = 0x1f1e6;
  return String.fromCodePoint(
    ...[...c.toUpperCase()].map((ch) => base + (ch.charCodeAt(0) - 65)),
  );
}
